import { SHIPPING_RATE_API } from '@/services/Configuration'
import Axios from 'axios'
import {
  bool,
  number,
  object,
  string,
  assertion,
  type CheckerReturnType,
  asType,
  nullable,
} from '@recoiljs/refine'
import { warn } from '@/services/Log'
import { thenCaught } from '@/helpers/FP'
import { ClientSideCache } from './ClientSideCache'

const DeliveryQuoteType = object({
  vendorLeadTime: asType(nullable(number()), (n) => n || 0),
  transitDays: number(),
  zipCode: string(),
  qualifiesForFreeShipping: bool(),
  state: object({
    code: string(),
  }),
})

export type DeliveryQuote = CheckerReturnType<typeof DeliveryQuoteType>

const assertDeliveryQuote = assertion(DeliveryQuoteType, 'DeliveryQuote Failed runtime type check')

const cacheBySku = ClientSideCache('services/getDeliveryQuote.ts::cacheBySku')((sku: string) => sku)

const getDeliveryQuoteSadPath = (err: unknown, sku: string) => {
  warn(`Failed to get delivery quote for sku:${sku}: ${String(err)}`, err)
  return null
}
const getDeliveryQuoteHappyPath = async (sku: string): Promise<DeliveryQuote | null> => {
  const { data: quote } = await Axios.get<unknown>(`${SHIPPING_RATE_API}/ratingAndTime?sku=${sku}&serviceLevel=parcel`)
  return assertDeliveryQuote(quote)
}

export const getDeliveryQuote = cacheBySku(
  thenCaught(getDeliveryQuoteHappyPath)(getDeliveryQuoteSadPath),
)

export const skusToDeliveryQuotesMap = async (
  skus: string[],
): Promise<Record<string, DeliveryQuote | null>> => {
  const quotes = await Promise.all(skus.map(getDeliveryQuote))
  return skus.reduce((acc, sku, i) => ({ ...acc, [sku]: quotes[i] }), {})
}
